import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import {UseLoader} from "../../../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../../components/Containers/ContainerForm";
import {
    crearFacturaEvento, crearFacturaHora,
    getContractByClient
} from "../../../../api/factura.service";
import {AutoComplete} from "primereact/autocomplete";
import {getInfoContrato} from "../../../../api/contrato.service";
import {ContainerGroupForm} from "../../../../components/Containers/ContainerGroupForm";
import {arrayNum, error} from "../../../../shared/utils/utils";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {confirmDialog} from "primereact/confirmdialog";
import {locales} from "../../../../shared/types/constantes";

export const ModalNuevaFactura = ({show, hide, cliente_id, name, tipo}) => {
    const [handleLoader] = UseLoader();
    const toast = useRef(null);
    const [selectedContract, setSelectedContract] = useState(null);
    const [contratos, setContratos] = useState([]);
    const [FilteredContratos, setFilteredContratos] = useState(null);
    const initParaminfoGenContratos = {
        contratomarco_id: "",
        contrato: '',
        cliente: '',
        disponible: '0',
        valor_facturado: '0',
        valorTotal: '0'
    }
    const [infoGenContratos, setInfoGenContratos] = useState(initParaminfoGenContratos);
    const fecha = new Date();

    let month = '' + (fecha.getMonth() + 1);
    let year = fecha.getFullYear();
    if (month.length < 2) month = '0' + month

    const initParams = {
        fecha: fecha,
        anio: year.toString(),
        mes: month,
        periodo: "",
        num_factura: "",
        concepto_factura: "",
        cant_horas: "",
        valor_factura: "0",
        concepto_descuento: "",
        valor_descuento: "0",
        valor_neto: "0"
    };

    const [field, setField] = useState(initParams);
    addLocale('es', locales);

    const periodo = arrayNum(50);
    const searchContrato = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...contratos];
            } else {
                _filteredCliente = contratos.filter((contrato) => {
                    return contrato.codigo.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredContratos(_filteredCliente);
        }, 250);
    }

    /* const renderFooter = () => {
         return (
             <div className="flex align-items-center justify-end">
                 <button
                     className="danger-color-btn btn"
                     type="button"
                     onClick={hide}
                 >
                     cerrar
                 </button>
             </div>

         );
     }*/

    const getContractByClientPromise = () => {
        if (cliente_id !== "" && show) {
            getContractByClient({
                cliente_id
            }).then(r => {
                if (r.data.length === 0) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "No se encontraron contratos para el cliente seleccionado",
                        life: 3000
                    });
                    return
                }
                ;

                setContratos(r.data)

            });
        }
    }
    const onSelect = (e) => {
        const info = e.value;
        if (info?.id != null) {
            getInfoContrato({
                contratomarcoId: info.id
            }).then(r => {
                const data = r.data.data.infoContrato;
                setInfoGenContratos({
                    ...infoGenContratos,
                    valorTotal: data?.valorTotal,
                    disponible: data?.disponible,
                    cliente: data?.cliente,
                    valor_facturado: data?.valor_facturado,
                    contrato: data?.contrato,
                    contratomarco_id: data?.contratomarco_id
                });
            })
        }
    }

    useEffect(() => {
        getContractByClientPromise();
        return () => {
            if (contratos.length > 0) {
                setContratos([]);
            }
            if (!show) {
                setInfoGenContratos(initParaminfoGenContratos);
                setSelectedContract(null);
                setField(initParams)
            }
        };
    }, [show]);

    useEffect(() => {
        const valorFactura = field.valor_factura === '' ? 0 : parseFloat(field.valor_factura);
        const valorDescuento = field.valor_descuento === '' ? 0 : parseFloat(field.valor_descuento);
        const total = valorFactura - valorDescuento;
     /*   if (total < 0) {
            if (field.cant_horas === '') {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "El descuento es mayor al valor facturado",
                    life: 3000
                });
                return;
            }

        }*/
        setField({...field, valor_neto: total.toString()})

    }, [field.valor_factura, field.valor_descuento]);

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.codigo}</div>
            </div>
        );
    }


    const onsubmit = (e) => {
        e.preventDefault();
        try {

            if (field.periodo === ''
                || field.num_factura === ''
                || field.concepto_factura === ''
                || field.mes === ''
                || field.anio === ''
                || field.valor_factura === ''
                || field.concepto_descuento === ''
                || field.valor_descuento === ''
                || field.valor_neto === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            if (tipo === "H") {
                if (field.cant_horas === '') {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "Validar campos",
                        life: 3000
                    });
                    return;
                }
            }
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoader(true)
                    let data;
                    const payload = {
                        ...field,
                        contratomarco_id: infoGenContratos.contratomarco_id,
                        cliente_id
                    }
                    if (tipo === 'E') {
                        const response = await crearFacturaEvento(payload);
                        data = await response;
                    } else if (tipo === 'H') {
                        const response = await crearFacturaHora(payload);
                        data = await response;
                    } else {
                        toast.current?.show({
                            severity: 'warn',
                            summary: 'Alerta',
                            detail: "No se ha logrado identificar el tipo de facturación para el clinte",
                            life: 3000
                        });
                        return;
                    }

                    handleLoader(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                     hide()

                }
            });

        } catch (e) {
            console.log(e)
        }
    }

    const onChangeCalendar = (e) => {
        const fecha = e.value;
        let month = '' + (fecha.getMonth() + 1);
        let year = fecha.getFullYear();
        if (month.length < 2) month = '0' + month

        setField({...field, fecha: fecha, anio: year.toString(), mes: month});
    }

    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header={`Crear factura para cliente ${name}`} visible={show}
                    style={{width: '90vw'}} onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <h6 className="title-modal">
                            Información contrato
                        </h6>

                        <div className="row pt-4 bg-lightBlue-400">
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form"
                                    htmlFor="cliente"
                                >
                                    Cliente
                                </label>
                                <input
                                    id="cliente"
                                    type="text"
                                    readOnly
                                    className="form-input-small"
                                    defaultValue={infoGenContratos.cliente}
                                />
                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form"
                                    htmlFor="codigo"
                                >
                                    Código
                                </label>
                                <input
                                    id="codigo"
                                    type="text"
                                    readOnly
                                    className="form-input-small"
                                    defaultValue={infoGenContratos.contrato}
                                />
                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-2/12">
                                <label
                                    className="label-form"
                                    htmlFor="valor_contrato"
                                >
                                    Valor contrato
                                </label>
                                <NumberFormat
                                    readOnly
                                    id="valor_contrato"
                                    thousandsGroupStyle="thousand"
                                    value={infoGenContratos.valorTotal}
                                    prefix="$"
                                    displayType="input"
                                    type="text"
                                    decimalSeparator="."
                                    className="form-input-small"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    onValueChange={e => null}
                                />
                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-2/12">
                                <label
                                    className="label-form"
                                    htmlFor="facturado"
                                >
                                    Valor facturado
                                </label>
                                <NumberFormat
                                    id="facturado"
                                    readOnly
                                    thousandsGroupStyle="thousand"
                                    value={infoGenContratos.valor_facturado}
                                    prefix="$"
                                    displayType="input"
                                    type="text"
                                    decimalSeparator="."
                                    className="form-input-small"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    onValueChange={e => null}
                                />

                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-2/12">
                                <label
                                    className="label-form"
                                    htmlFor="dispo"
                                >
                                    Disponible
                                </label>
                                <NumberFormat
                                    id="dispo"
                                    readOnly
                                    thousandsGroupStyle="thousand"
                                    value={infoGenContratos.disponible}
                                    prefix="$"
                                    displayType="input"
                                    type="text"
                                    decimalSeparator="."
                                    className="form-input-small"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    onValueChange={e => null}
                                />
                            </ContainerGroupForm>
                        </div>

                        <hr className="mt-6 border-b-1 border-blueGray-300"/>
                        <div className="row">
                            <ContainerGroupForm width="lg:w-6/12 mt-3">
                                <label className="label-form" htmlFor="valorNeto">
                                    Buscar Contrato
                                </label>
                                <AutoComplete value={selectedContract} suggestions={FilteredContratos}
                                              completeMethod={searchContrato}
                                              style={{width: "100%"}}
                                              placeholder="Buscador contrato"
                                              size="30"
                                              field="codigo" dropdown itemTemplate={itemTemplate}
                                              onSelect={onSelect}
                                              onChange={(e) => setSelectedContract(e.value)}/>
                            </ContainerGroupForm>

                            {infoGenContratos.contrato.length > 0 && <ContainerGroupForm width="lg:w-4/12 mt-3">
                                <label className="label-form" htmlFor="valorNeto">
                                    Valor neto
                                </label>

                                <NumberFormat
                                    readOnly
                                    id="valorNeto"
                                    thousandsGroupStyle="thousand"
                                    value={field.valor_neto}
                                    prefix="$"
                                    displayType="input"
                                    type="text"
                                    decimalSeparator="."
                                    className="form-input"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                    onValueChange={e => null}
                                />
                            </ContainerGroupForm>}

                        </div>


                        <hr className="mt-6 border-b-1 border-blueGray-300"/>
                        {infoGenContratos.contrato.length > 0 &&
                        <form className="mt-6" onSubmit={onsubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Crear factura
                            </h6>

                            <div className="row">
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="fechacrea"
                                    >
                                        Fecha *
                                    </label>
                                    <Calendar id="fechacrea"
                                              value={field.fecha}
                                              locale="es"
                                              touchUI
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange='2010:2030'
                                              dateFormat="yy-mm-dd"
                                              style={{width: "100%"}}
                                              onChange={onChangeCalendar}
                                              showIcon/>
                                    {error(field.fecha, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <label
                                        className="label-form"
                                        htmlFor="periodo"
                                    >
                                        periodo *
                                    </label>
                                    <select value={field.periodo} name="periodo"
                                            className="form-input"
                                            onChange={(e) => setField({...field, periodo: e.target.value})}
                                            id="periodo">
                                        <option value="">Seleccione...</option>
                                        {periodo.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                    </select>
                                    {error(field.periodo, 'required')}
                                    {error(field.periodo, 'maxLength', 3)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="num_factura"
                                    >
                                        N. Factura *
                                    </label>
                                    <input
                                        id="num_factura"
                                        type="text"
                                        value={field.num_factura}
                                        className="form-input"
                                        onChange={(e) => setField({...field, num_factura: e.target.value})}
                                    />
                                    {error(field.num_factura, 'required')}
                                    {error(field.num_factura, 'maxLength', 30)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="concepto"
                                    >
                                        Concepto factura *
                                    </label>

                                    <textarea
                                        value={field.concepto_factura}
                                        onChange={(e) => setField({...field, concepto_factura: e.target.value})}
                                        name="concepto"
                                        id="concepto"
                                        className="form-input"
                                        rows="1">
                                    </textarea>
                                    <br/>
                                    {error(field.concepto_factura, 'required')}
                                    {error(field.concepto_factura, 'maxLength', 250)}
                                </ContainerGroupForm>

                                {tipo === "H" &&
                                <ContainerGroupForm width="lg:w-2/12">
                                    <label
                                        className="label-form"
                                        htmlFor="horas"
                                    >
                                        Cantidad Horas *
                                    </label>
                                    <input
                                        id="horas"
                                        type="number"
                                        className="form-input"
                                        value={field.cant_horas}
                                        onChange={(e) => setField({...field, cant_horas: e.target.value})}
                                    />
                                    {error(field.cant_horas, 'required')}
                                </ContainerGroupForm>
                                }


                                <ContainerGroupForm width="lg:w-2/12">
                                    <label
                                        className="label-form"
                                        htmlFor="valor"
                                    >
                                        Valor factura *
                                    </label>
                                    <NumberFormat
                                        id="valor"
                                        thousandsGroupStyle="thousand"
                                        value={field.valor_factura}
                                        prefix="$"
                                        displayType="input"
                                        type="text"
                                        decimalSeparator="."
                                        className="form-input"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        onValueChange={e => setField({...field, valor_factura: e.value})}
                                    />
                                    {error(field.valor_factura, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="concepto"
                                    >
                                        Concepto del Gasto *
                                    </label>

                                    <textarea
                                        value={field.concepto_descuento}
                                        onChange={(e) => setField({...field, concepto_descuento: e.target.value})}
                                        name="concepto"
                                        id="concepto"
                                        className="form-input"
                                        rows="1">
                                    </textarea>
                                    <br/>
                                    {error(field.concepto_descuento, 'required')}
                                    {error(field.concepto_descuento, 'maxLength', 250)}
                                </ContainerGroupForm>
                                {field.valor_factura !== '' && <ContainerGroupForm width="lg:w-2/12">
                                    <label
                                        className="label-form"
                                        htmlFor="valorDes"
                                    >
                                        Gastos del contrato *
                                    </label>
                                    <NumberFormat
                                        id="valorDes"
                                        thousandsGroupStyle="thousand"
                                        value={field.valor_descuento}
                                        prefix="$"
                                        displayType="input"
                                        type="text"
                                        decimalSeparator="."
                                        className="form-input"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        onValueChange={e => setField({...field, valor_descuento: e.value})}
                                    />
                                    {error(field.valor_descuento, 'required')}
                                </ContainerGroupForm>}
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>

                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>}
                    </ContainerForm>
                </div>

            </Dialog>
        </>
    );
};

ModalNuevaFactura.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func,
    name: PropTypes.string,
};

ModalNuevaFactura.defaultProps = {
    show: false,
    name: ""
}


